import type { RnViewJobDisplay } from "../../../../context/ViewJobDisplayContext";

import { isJobFromHomePageWeb, isJobFromSerpWeb } from "../../../../utils/fromParamUtils";

export const SAVE_JOB_AUTH_REDIRECT_STANDALONE_FROM_PARAMETER = "jsfe-viewjob-standalone-save-job";
export const SAVE_JOB_AUTH_REDIRECT_SERP_EMBEDDED_FROM_PARAMETER = "jsfe-serp-embedded-save-job";
export const SAVE_JOB_AUTH_REDIRECT_HOMEPAGE_EMBEDDED_FROM_PARAMETER =
  "jsfe-homepage-embedded-save-job";
export const SAVE_JOB_AUTH_REDIRECT_EMBEDDED_FROM_PARAMETER = "jsfe-embedded-save-job";

export function getSaveJobAuthRedirectFromParameter({
  from,
  viewJobDisplay,
}: {
  from?: string | null;
  viewJobDisplay: RnViewJobDisplay;
}): string {
  if (viewJobDisplay !== "DESKTOP_EMBEDDED") {
    return SAVE_JOB_AUTH_REDIRECT_STANDALONE_FROM_PARAMETER;
  }

  if (isJobFromSerpWeb(from)) {
    return SAVE_JOB_AUTH_REDIRECT_SERP_EMBEDDED_FROM_PARAMETER;
  }

  if (isJobFromHomePageWeb(from)) {
    return SAVE_JOB_AUTH_REDIRECT_HOMEPAGE_EMBEDDED_FROM_PARAMETER;
  }

  return SAVE_JOB_AUTH_REDIRECT_EMBEDDED_FROM_PARAMETER;
}

function getSecureOrigin(domain: string, legacyLoginUrl?: string | null): string {
  if (legacyLoginUrl) {
    try {
      return new URL(legacyLoginUrl).origin;
    } catch {
      // Fall through to the domain-derived host.
    }
  }

  return domain.includes("qa.indeed.net")
    ? "https://secure.qa.indeed.net"
    : "https://secure.indeed.com";
}

function getAbsoluteContinueUrl(viewjobSourceUrl: string, domain: string): string {
  const baseUrl = domain.startsWith("http") ? domain : `https://${domain || "www.indeed.com"}`;
  return new URL(viewjobSourceUrl || "/", baseUrl).toString();
}

export function createSaveJobAuthRedirectUrl({
  domain,
  from,
  viewjobSourceUrl,
  viewJobDisplay,
  legacyLoginUrl,
}: {
  domain: string;
  from?: string | null;
  viewjobSourceUrl: string;
  viewJobDisplay: RnViewJobDisplay;
  legacyLoginUrl?: string | null;
}): string {
  const url = new URL("/auth", getSecureOrigin(domain, legacyLoginUrl));
  url.searchParams.set("continue", getAbsoluteContinueUrl(viewjobSourceUrl, domain));
  url.searchParams.set("from", getSaveJobAuthRedirectFromParameter({ from, viewJobDisplay }));
  return url.toString();
}

export function navigateToSaveJobAuthRedirect(authRedirectUrl: string): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (window.parent && window.parent !== window) {
      window.parent.location.href = authRedirectUrl;
      return;
    }
  } catch {
    // Cross-origin parent access can throw; fall back to navigating this frame.
  }

  window.location.href = authRedirectUrl;
}
